export class ParameterModel {
    parameterID: number;
    key: string;
    value: string;
    displayText: string;
    inputType: string;
    enableEdit: boolean;
    updatorID: number;
    lastUpdate: Date;
}


// WEBPACK FOOTER //
// ./src/app/_models/parameter.model.ts